import {
    SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT,
    SET_START_DATE,
    SET_END_DATE
} from "../actions/types";

const initialState = {
    formDataFromTableEmailAudit: {},
    startDate: '',
    endDate: ''
};

const EmailAuditReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_FORM_DATA_FROM_TABLE_EMAIL_AUDIT:
            return { ...state, formDataFromTableEmailAudit: payload };
        case SET_START_DATE:
            return { ...state, startDate: payload }
        case SET_END_DATE:
            return {...state, endDate: payload}
        default:
            return state;
    }
};

export default EmailAuditReducer;